<div class="cs-ticket-dialog-container">
  <button class="close-button" (click)="onClose()" aria-label="Close dialog">
    <mat-icon>close</mat-icon>
  </button>
  <div id="cs-ticket-hubspot-form-container"></div>
</div>